export default __webpack_public_path__ + "static/media/kg.34d44976.svg";